import React from "react";

export default function SegmentedProgressBar({ value = 0, max = 8, label, sublabel }) {
  const completed = Math.min(value, max);
  const percentage = Math.round((completed / max) * 100);

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm font-semibold text-[#0F172A] font-[Manrope]">{label}</p>
          {sublabel && <p className="text-xs text-[#475569]">{sublabel}</p>}
        </div>
        <div className="text-right">
          <span className="text-lg font-bold text-[#002147] font-[Outfit]">{completed}</span>
          <span className="text-sm text-[#475569]">/{max}</span>
        </div>
      </div>
      <div className="flex gap-1">
        {Array.from({ length: max }).map((_, i) => (
          <div
            key={i}
            data-testid={`progress-segment-${i}`}
            className={`flex-1 h-5 rounded-sm transition-all duration-300 ${
              i < completed
                ? "bg-[#002147]"
                : "bg-slate-200"
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-[#475569]">
        {completed >= max
          ? "Syarat bimbingan terpenuhi"
          : `${max - completed} sesi lagi untuk memenuhi syarat`}
      </p>
    </div>
  );
}
